<template>
  <div class="form-box">
    <div class="form-box-item">
      <!-- 步骤序号/工作模式  -->
      <div class="flex-space-between">
        <div class="flex">

          <el-form-item :label="$t('lang.步骤序号')">
            <el-input
                disabled
                v-model="stepItem.number"
                type="number"
                @change="(e) => $emit('changeSort', e)"/>
          </el-form-item>


          <template v-if="multiTypeList.length">
            <el-form-item :label="$t('lang.锅体类型')" required>
              <el-select v-model="stepPotType" clearable @change="handleChangePotType">
                <el-option
                    v-for="item in multiTypeList"
                    :key="item.value"
                    :value="item.value"
                    :label="$t(`lang.${item.label}`)"/>
              </el-select>
            </el-form-item>
          </template>


          <el-form-item :label="$t('lang.双锅类型')" required v-if="showDoublePot">
            <el-select v-model="stepItem.workPot" clearable>
              <el-option value="UP" :label="$t('lang.上锅')"/>
              <el-option value="DOWN" :label="$t('lang.下锅')"/>
              <el-option value="ALL" :label="$t('lang.上下锅')"/>
            </el-select>
          </el-form-item>


          <el-form-item :label="$t('lang.工作模式')" required v-if="showUpPotParams">
            <div style="display: flex;">
              <div class="select-mask" @click="handleSelectMode">
                <el-select :disabled="wordModeDisabled"
                           v-model="stepItem.workMode"
                           :placeholder="$t('lang.请选择')"
                           @change="handleChangeWorkMode">
                  <el-option
                      v-for="m in modelList"
                      :key="m.value"
                      :label="m.name"
                      :value="m.value"/>
                </el-select>
              </div>

              <el-popover
                  v-if="stepItem.workMode"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="$t(`lang.${TH_WORK_MODE[stepItem.workMode]}`)">
                <i class="el-icon-question explain" slot="reference"/>
              </el-popover>
            </div>
          </el-form-item>
          <mode-list ref="modeDialog"/>
        </div>

        <i class="el-icon-circle-close input-icon" @click="handleDeleteItem" v-if="!disabled"/>
      </div>

      <el-form-item :label="$t('lang.描述文字')">
        <nation-input :placeholder="$t('lang.描述文字可填写可不填写')" :list="supportLangList" type="textarea" :rows="5"
                      :lang="lang" v-model="stepItem.stepLang"
                      :disabled="disabledDesc"/>
      </el-form-item>

      <el-form-item :label="$t('lang.图片/视频')">

        <UploadFile :type="['image', 'video']" :show-input="false" v-if="!stepItem.photoVideoFileCode"
                    category="COOKING" @upload="(e) => {handleUploadFile(e)}">

          <el-button icon="el-icon-upload2" size="small" type="primary">{{ $t('lang.选择文件') }}</el-button>

          <el-link v-if="index != 0" type="warning" :underline="false" @click.stop="$emit('syncPhoto', stepItem)"
                   class="ml12">
            {{ $t('lang.同步') }}
          </el-link>
        </UploadFile>


        <div class="media-row" v-else>
          <i class="el-icon-circle-close input-icon" @click="handleRemoveFile()" v-if="!disabled"/>
          <video width="300" height="140" controls="controls" :src="stepItem.photoVideoFileCode | filterImg"
                 v-if="stepItem.photoVideoFileType == 'video'"></video>

          <el-image class="image" :src="stepItem.photoVideoFileCode | filterImg"
                    v-else></el-image>

        </div>

        <span
            style="color: orangered;font-size: 12px;">{{
            $t('lang.此处可选择食谱图片，如果不上传图片，食谱在机器显示为空白背景')
          }}</span>
      </el-form-item>

      <el-form-item :label="$t('lang.音频')">
        <UploadFile type="audio" :show-input="false" v-if="!stepItem.audioFileCode" category="COOKING"
                    @upload="(e) => {handleUploadFile(e, 'audio')}">
          <el-button icon="el-icon-upload2" size="small" type="primary">{{ $t('lang.选择文件') }}</el-button>
        </UploadFile>

        <div class="media-row" v-else>
          <i class="el-icon-circle-close input-icon" @click="handleRemoveFile('audio')" v-if="!disabled"/>
          <audio :src="stepItem.audioFileCode | filterImg" controls="controls"></audio>
        </div>
      </el-form-item>


      <template v-if="showConf(devMode ? devMode.mode : '')">
        <div class="pot-title" v-if="showDoublePot && ['ALL'].includes(stepItem.workPot)">{{ $t('lang.上锅') }}：</div>

        <!-- 上锅参数字段 -->
        <first-pot-params
            v-if="showUpPotParams"
            :step-item="stepItem"
            :dev-mode="devMode"
            :type="type"
            :rotate-direction="rotateDirection"/>
      </template>


      <!-- 下锅工作模式和参数 -->
      <div v-if="showDoublePot && ['DOWN', 'ALL'].includes(stepItem.workPot)">
        <div class="pot-title" v-if="['ALL'].includes(stepItem.workPot)">{{ $t('lang.下锅') }}：</div>
        <second-pot-params
            :step-item="stepItem"
            :work-model-list="workModelList"
            :type="type"
            :step-pot-type="stepPotType"
            :disabled="disabled"
            :rotate-direction="rotateDirection"/>
      </div>


      <!-- 烤箱专用参数 -->
      <template v-if="type === 'OVEN'">
        <div style="display: flex">
          <!-- 热风 -->
          <oven-hot-air
              v-model="stepItem.ovenHotAir"
              :permissions="permissions"
              @change="handleChangeOvenHotAir"/>

          <!-- 发热方式 -->
          <oven-heat-type
              v-model="stepItem.ovenHeatType"
              :permissions="permissions"
              :hot-wind-list="hotWindList"/>
        </div>
      </template>
    </div>

    <el-button
        type="info"
        style="width: 100%"
        icon="el-icon-circle-plus-outline"
        @click="$emit('add')"
        v-if="!disabled">
      {{ $t('lang.添加步骤') }}
    </el-button>
  </div>
</template>

<script>
import UploadFile from "../upload-file/UploadFile";
import NationInput from "../nation/NationInput";
import {TH_WORK_MODE, showConf} from "./utils";
import ModeList from "./ModeList";
// 参数字段组件
import OvenHotAir from "./params/OvenHotAir";
import OvenHeatType from "./params/OvenHeatType";
// 锅体参数组件
import FirstPotParams from "./FirstPotParams";
import SecondPotParams from "./SecondPotParams";
// 共用逻辑 mixin
import potParamsMixin from "./mixins/potParamsMixin";

export default {
  name: "StepItem",
  mixins: [potParamsMixin],
  components: {
    ModeList,
    NationInput,
    UploadFile,
    OvenHotAir,
    OvenHeatType,
    FirstPotParams,
    SecondPotParams
  },
  model: {
    event: "change",
    prop: "stepItem"
  },
  props: {
    workModelList: {
      type: Array,
      default() {
        return []
      }
    },
    stepItem: {
      type: Object,
      default() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    rotateDirection: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      formData: {},
      devMode: null,
      TH_WORK_MODE,
      stepPotType: ""
    }
  },
  created() {
    if (this.stepItem.workMode) {
      this.devMode = this.$store.state.devModes[this.stepItem.workMode];
    }

  },
  methods: {
    showConf,
    handleDeleteItem() {
      this.$emit('delStep', this.stepItem);
      this.$nextTick(() => {
        this.devMode = this.$store.state.devModes[this.stepItem.workMode];
      })
    },

    // 切换有无热风
    handleChangeOvenHotAir() {
      this.stepItem.ovenHeatType = "";
    },


    // 选择模式
    handleSelectMode() {
      this.$refs.modeDialog.showDialog(this.modelList, this.stepItem.workMode, (res) => {
        this.devMode = null;
        this.stepItem.workMode = res.value;
        this.handleChangeWorkMode(res.value);
      })
    },

    // 切换锅体类型
    handleChangePotType() {
      this.stepItem.workMode = "";
      this.devMode = null;
      this.stepItem.temperature = null;
      this.stepItem.rotateDirection = null;
      this.stepItem.rotateSpeed = null;
      this.stepItem.waterGear = null;
      this.stepItem.minute = null;
      this.stepItem.second = null;
    },

    // 删除文件
    handleRemoveFile(type) {
      if (type == 'audio') {
        this.stepItem.audioFileCode = '';
        return;
      }
      this.stepItem.photoVideoFileCode = '';
      this.stepItem.photoVideoFileType = '';
    },

    handleUploadFile(file, key) {
      let {type} = file.file;
      let mediaType = type.split('/')[0];
      if (key == 'audio') {
        this.stepItem.audioFileCode = file.data.fileCode;
        return;
      }
      this.stepItem.photoVideoFileCode = file.data.fileCode;
      this.stepItem.photoVideoFileType = mediaType == 'image' ? 'photo' : 'video';
    },

    resetWorkParams() {
      [
        'temperature',
        'rotateDirection',
        'rotateSpeed',
        'waterGear',
        'minute',
        'second',
        'ovenHotAir',
        'ovenHeatType'
      ].forEach(key => this.$set(this.stepItem, key, null));
    },

    handleChangeWorkMode(mode) {
      // 先清空上一个工作模式的参数，再设置新模式的默认值
      this.resetWorkParams();
      let devMode = this.$store.state.devModes[mode];
      if (!devMode || !showConf(mode)) {
        this.devMode = null;
        return;
      }
      // this.stepItem.devMode = devMode;
      this.devMode = devMode;
      this.stepItem.temperature = devMode.defaultTemp;
      this.stepItem.rotateDirection = devMode.motorDirection + "";
      this.stepItem.rotateSpeed = devMode.defaultMotorGear;
      this.stepItem.minute = parseInt((devMode.defaultTime / 60));
      this.stepItem.second = parseInt((devMode.defaultTime % 60));

      // 烤箱配置
      if (this.type === "OVEN") {
        this.$set(this.stepItem, "ovenHotAir", devMode.ovenHotAir + "");
        this.$set(this.stepItem, "ovenHeatType", devMode.ovenHeatType + "");
      }

    },
  },
  computed: {
    supportLangList() {
      return this.$store.state.recipe.supportLangList;
    },
    lang() {
      return this.$store.state.recipe.lang;
    },

    type() {
      return this.$store.state.recipe.type;
    },

    // 禁用描述输入
    disabledDesc() {
      if (this.disabled) return true;
      if (["AIR_FRYER", "STAND_MIXER"].includes(this.type)) {
        // 小系统的机型禁用输入描述
        return !["AF_DESCRIPTION", "AF_WARNING", "SM_DESCRIPTION", "SM_WARNING"].includes(this.stepItem.workMode);
      }
      // 烤箱（diy/预热）禁用输入描述
      if (this.type === "OVEN") {
        return ["OVEN_ADAPTED_COOKING", "OVEN_PREHEAT"].includes(this.stepItem.workMode);
      }

      return false;
    },

    workModelAndItemWorkModel() {
      return {list: this.workModelList, model: this.stepItem.workMode}
    },

    // 热风模式列表
    hotWindList() {
      const list = this.$store.state.hostWindMode || [];
      // 过滤掉无效项，确保所有元素都有 value 属性
      const validList = list.filter(i => i && i.value !== undefined && i.value !== null);
      if (!this.stepItem.ovenHotAir || this.stepItem.ovenHotAir === "0") {
        return validList.filter(i => !["1"].includes(String(i.value)));
      }
      return validList;
    },

    // 是否显示双锅配置
    showDoublePot() {
      const {products, type} = this.$store.state.recipe;
      let productModelCodes = products || [];
      // 过滤重复
      productModelCodes = [...new Set(productModelCodes)];
      if (!['AIR_FRYER_DOUBLE_DECK', 'AIR_FRYER'].includes(type) || productModelCodes.length > 1) return false;
      // 目前只有9019
      return productModelCodes.includes('f87ca53f09d5418f8c0e988fc45749c4');
    },

    // 是否显示上锅参数配置
    showUpPotParams() {
      if (!this.showDoublePot) return true;
      return ['UP', 'ALL'].includes(this.stepItem.workPot);
    }

  },
  watch: {
    stepItem: {
      handler(val) {
        this.$emit("change", val);
      },
      immediate: true,
    },

    showDoublePot: {
      handler(val) {
        if (val && !this.stepItem.workPot) {
          this.$set(this.stepItem, 'workPot', 'UP')
        }
      },
      immediate: true,
    },

    workModelAndItemWorkModel: {
      handler({list, model}) {
        if (this.multiTypeList.length && !this.stepPotType && model && list.length) {
          let modelItem = list.find(item => item.value === model);
          if (modelItem) this.stepPotType = modelItem.data;
        }
      },
      immediate: true,
      deep: true,
    }
  }
}
</script>

<style scoped>


.flex {
  display: flex;
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
}

.ml12 {
  margin-left: 12px;
}

.input-icon {
  font-size: 26px;
  color: red;
}

.form-box {
  width: 1100px;
  margin-bottom: 16px;
}

.form-box-item {
  width: 100%;
  background: #fcfcfc;
  border: 1px solid #dddddd;
  padding: 12px;
  margin-bottom: 24px;
  box-sizing: border-box;
}

.image {
  width: 300px;
  height: 200px;
}

.media-row {
  display: flex;
  flex-direction: column;
  background: #eeeeee;
  border-radius: 10px;
  width: 320px;
  align-items: flex-end;
  box-sizing: border-box;
  padding: 6px;
}

.media-row .input-icon {
  margin-bottom: 6px;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type='number'] {
  -moz-appearance: textfield !important;
}

.explain {
  font-size: 20px;
  margin-left: 16px;
}

.select-mask {
  width: 217px;
  height: 40px;
  position: relative;
}

.select-mask::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  cursor: pointer;
}

.pot-title {
  margin-left: 20px;
  color: #606266;
  font-size: 14px;
}

</style>
